import React, { useState } from 'react';
import "./Home_page_product6.css";
import { useNavigate } from 'react-router-dom';

function Home_page_product6() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([
    {
      url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2024/04/5th-Banner-1000600-3.png',
      search: 'Mobile'
    },
    {
      url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2024/04/5th-Banner-1000600-1.png',
      search: 'TV'
    },
    {
      url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2024/04/5th-Banner-1000600-2.png',
      search: 'Laptop'
    }]);
  return (
    <div className="Home_page_product6_container">
      <div className="Home_page_product6_product_grid">
        {products.map((product, index) => (
          <img src={product.url} key={index} className="img-fluid" onClick={() => navigate(`/category/${product.search}`)}/>
        ))}
      </div>
    </div>
  );
}


export default Home_page_product6;